import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Answer, Question } from '@haleo-frontend/data-access/models';

import { AddElementCheckboxModal } from './add-element-checkbox.modal';

@Component({
    selector: 'app-thought-record-question-checkbox',
    templateUrl: 'checkbox.component.html',
    styleUrls: ['checkbox.component.scss']
})
export class CheckboxComponent implements OnChanges {

    @Input() question: Question;
    @Input() answer: Answer | undefined;
    @Input() integrated: boolean;
    @Input() readOnly: boolean;
    @Output() answered: EventEmitter<any>;

    showList: boolean;
    enableNext: boolean;
    options: { label: any, value: any, checked: boolean }[];
    optionsCount: number;

    constructor(private modalCtrl: ModalController) {
        this.answered = new EventEmitter<any>();
    }

    ngOnChanges(changes: SimpleChanges): void {

        if (this.question) {

            let selectedValues: any = [];
            if (this.answer && this.answer.value) {
                selectedValues = JSON.parse(this.answer.value);
            }

            const data = JSON.parse(this.question.options);

            this.options = [];
            this.optionsCount = 0;
            Object.keys(data.options).forEach(key => {

                const checked = selectedValues.findIndex((value: any) => value === key) >= 0;

                if (!this.integrated || (this.integrated && checked)) {

                    this.options.push({
                        label: data.options[key],
                        value: key,
                        checked: checked
                    });
                }

                this.optionsCount++;
            });

            this.enableNext = this.options.filter(option => option.checked).length > 0;
        }
    }

    change(option: any) {
        option.checked = !option.checked;
        this.enableNext = this.options.filter(option => option.checked).length > 0;
    }

    remove(option: any) {
        const index = this.options.findIndex(o => o.value === option.value);
        this.options.splice(index, 1);
    }

    continue() {
        const selectedValues = this.options.filter(option => option.checked).map(option => option.value);
        this.answered.emit(JSON.stringify(selectedValues));
    }

    async add() {

        const data = JSON.parse(this.question.options);
        const options: any = [];
        Object.keys(data.options).forEach(key => {

            const checked = this.options.findIndex(option => option.value === key) >= 0;

            if (!checked) {

                options.push({
                    label: data.options[key],
                    value: key
                });
            }
        });

        const modal = await this.modalCtrl.create({
            component: AddElementCheckboxModal,
            componentProps: {options},
            mode: 'ios',
            backdropDismiss: true
        });
        await modal.present();

        const result = await modal.onDidDismiss();

        if (result.data) {
            result.data.checked = true;
            this.options.push(result.data);
        }
    }
}
